export default "__VITE_ASSET__CWs3LPwX__"